import PanelBox from '../../components/PanelBox';
import ActionMenu from '../../components/ActionMenu';
import JobsMenu, {DataFlowItem, DeleteJobComponent} from './actionStaffMenu';
import JobStatusComponent from './statusComponent';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Input, Icon, Row, Col, Modal, Radio, Dropdown, DatePicker} from 'antd';
import { getTechJobs2, deleteJob } from '../../actions/jobs';
import moment from 'moment';
import { public_path, tech_api, client_api, type as app_type } from "../../api.json";


// import ct from '../../assets/svgicons/DeepCBCT_analysis.svg';
import plan_roots from '../../assets/svgicons/3d-plan_Roots_add.svg';
// import plan_roots from '../../assets/svgicons/3d-plan_roots.svg';
// import plan_deepct from '../../assets/svgicons/3d-plan_DeepCBCT.svg';

const { RangePicker } = DatePicker;

const dateFormat = 'YYYY-MM-DD';

const dateFormatList = ['YYYY-MM-DD'];

const actions = {
  plan_standart: [
    {
      icon: plan_roots,
      link: (uuid) => `/case/upload/plan-roots/${ uuid }`,
      title: '3D-Plan Roots'
    }
  ],
};

const case_status = {
  "S_DICOM_DOWNLOAD" : "Downloading DICOMs",
  "S_DICOM_CONVERT" : "Converting DICOMs",
  "S_DATA_CHECK" : "Check incoming data",
  "S_NN_SEGMENT" : "Automatic segentation",
  "S_TEETH_SEPARATION" : "Teeth separation",
  "S_AUTO_3D_TEETH_LABELING" : "Auto teeth labeling",
  "S_BUILD_MODELS" : "3D models building",
  "S_TRANSFER_ALIGN" : "Alignment transfer",
  "S_PUBLISH_RESULT" : "Results publishing",
  "S_DATA_DOWNLOAD" : "Data downloading",
  "S_XLS_PARSE" : "XLS parsing",
  "S_DATA_UPDATE" : "Update plan data",
  "S_CENTROID_COMPUTE" : "IPR computing",
  "S_OCCLUSION_COMPUTE" : "Occlusogram computing",
  "S_PUBLISH" : "Publishing",
  "S_ASSETS_CREATE" : "Assets creating",
  "S_PDF_RENDER" : "PDF rendering",
  "S_QUALITY_CONTROL" : "Quality control",
  "S_ALIGN_MANUAL": "Manual alignment",
  "S_TEETH_ROI_QUALITY_CONTROL": "Check Teeth ROI",
  "S_TEETH_ROI": "Compute Teeth ROI",
  "S_OCCLUSAL_PLANE_SETUP": "Occlusal plane setup",
  "S_OCCLUSAL_PLANE": "Occlusal plane orientation",
  "S_TRIM_BASE": "Model base trim setup",
  "S_GENERATE_BASE": "Model base creation",
  "S_TEETH_MARKUP": "Teeth markup",
  "S_CROWN_SEGMENTATION": "Crown segmentation",
  "S_SEGMENTED_ASSET_CREATION": "Segmented asset creation",
  "S_LOCAL_C_S": "Crown local coordinates setup",
  "S_MODELLING": "Movement Modelling",
  "S_CLINICIAN_REVIEW" : "Clinician review",
  0: "Draft",
  1: "Link for upload generated",
  '-20': "Failed"
}

const tableTypes = {
  ct: 'DeepCT analysis',
  ct_align: 'DeepCBCT analysis v1.1 (align)',
  ct_v2: 'DeepCT analysis v2',
  ct_v2_auto: 'DeepCT analysis v2 auto',
  plan_standart: 'Crowns plan',
  plan_roots: 'Roots plan',
  plan_deep_ct: 'DeepCT plan',
  plan_standard_orthostudio: 'Crowns plan Orthostudio',
  plan_standard_3shape_1c: 'Crowns plan 3Shape',
  plan_standard_3shape_color: 'Crowns plan 3Shape Color',
  plan_standard_archform_1c: 'Crowns plan Archform',
  plan_standard_onyxceph: 'Crowns plan OnyxCeph',
  plan_standard_orthostudio_v5: 'Crowns plan Orthostudio v5',
  plan_standard_suresmile_sou: 'Crowns plan SureSmile',
  teeth_alignment_modelling: 'Teeth alignment modelling'
};

const JON_WAITING_JOBS = [0, 1, -20];
const JOB_STATUS_WAITING = "waiting";
const JOB_STATUS_ALL = "all";
const FLOW_STEP_TYPE_MANUAL = 0;

function isWaitingJob(status) {
  return JON_WAITING_JOBS.indexOf(status) > -1 ? true : false;
}

const mapStateToProps = (state) => {
  let jobs = state.jobs || [];
  return {
    jobs: jobs,
    isSupervisor: state.user.is_supervisor,
    waitingJobs: jobs.filter(job => isWaitingJob(job.status))
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getTechJobs2: (date_from, date_to) => dispatch(getTechJobs2(date_from, date_to)),
    eraseJobs: () => dispatch({type: 'ERASE_JOBS'}),
    deleteJob: (uuid) => dispatch(deleteJob(uuid))
  }
}


class CaseTableStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shareModal: false,
      uuid: null,
      sorted_jobs: [],
      searchValue: '',
      tableLoading: false,
      filterWaitingJobs: false,
      sortedInfo: {
        order: 'descend',
        columnKey: 'created',
      },
    };
  }


  shouldShowWaitingRadioButton() {
    return this.props.waitingJobs.length > 0
  }

  componentDidMount() {
    this.props.getTechJobs2(moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
    this.setState({'tableLoading': true})
  }

  componentWillReceiveProps(nextProps) {
    nextProps.jobs ? this.setState({tableLoading: false}) : null
  }

  componentWillUnmount() {
    this.props.eraseJobs()
  }

  requestJobs(date_from, date_to) {
    this.props.getTechJobs2(date_from, date_to)
    this.setState({'tableLoading': true})
  }

  isManualStep(data) {
    return data.flow_step_queue && data.flow_step_queue.step.step_type == FLOW_STEP_TYPE_MANUAL;
  }

  shouldShowDeleteButton(data) {
    return isWaitingJob(data.status) || data.flow_step_queue && data.flow_step_queue.step.step_type == FLOW_STEP_TYPE_MANUAL;
  }

  filterByWaitingJobs(jobs) {
    let hasWaitingJobs = this.props.waitingJobs.length > 0;
    if (hasWaitingJobs) {
      if (this.state.filterWaitingJobs) {
        jobs = jobs.filter(job => isWaitingJob(job.status) === true);
      } else {
        jobs = jobs.filter(job => isWaitingJob(job.status) === false);
      }
    }
    return jobs;
  }

  filterJobs(searchText) {
    let filtred_data = []
    let table_data = this.props.jobs;
    if (searchText !== '') {
      table_data.map((record) => {
        let match = false
        Object.values(record).map((value) => {
          if (value && Object.values(value).length) {
            Object.values(value).map((subvalue)=>{
              if (subvalue && subvalue.toString().toUpperCase().indexOf(searchText.toUpperCase()) != -1) {
                match = true
              }
            })
          } else if (value && value.toString().toUpperCase().indexOf(searchText.toUpperCase()) != -1) {
            match = true
          }
        })
        match ? filtred_data.push(record) : null
      })
    } else {
      filtred_data = this.props.jobs;
    }
    return this.filterByWaitingJobs(filtred_data);
  }

  onSearchHandler(searchText) {
    this.setState({'searchValue':searchText});
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  handleCaseTableRadioSwitch = e => {
    const { value } = e.target;
    this.setState({'filterWaitingJobs':value === JOB_STATUS_WAITING});
  };

  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};

    const source = this.filterJobs(this.state.searchValue);

    const columns = [{
      title: 'id',
      dataIndex: 'uuid',
      render: (id) => id.slice(0,8),
      key: 'id',
      sorter: (a, b) => a.uuid - b.uuid,
      sortOrder: sortedInfo.columnKey === 'id' && sortedInfo.order,
    }, {
      title: 'Owner',
      dataIndex: 'member',
      key: 'member',
      render: (member) => {
        let res = '';
        if (member) {
          if (member.username) {
            res = member.username;
          } else if (member.first_name && member.last_name) {
            res = `${ member.first_name } ${ member.last_name }`;
          }
        }
        return res;
      },
      // sorter: (a, b) => a.ct_scan.patient_tag - b.ct_scan.patient_tag,
      // sortOrder: sortedInfo.columnKey === 'patient_tag' && sortedInfo.order,
    }, {
      title: 'Patient tag',
      dataIndex: 'ct_scan.patient_tag',
      key: 'patient_tag',
      sorter: (a, b) => a.ct_scan.patient_tag - b.ct_scan.patient_tag,
      sortOrder: sortedInfo.columnKey === 'patient_tag' && sortedInfo.order,
    }, {
      title: 'Status',
      key: 'status',
      render: (data) => {
        let status = "";
        if (data.flow_step_queue && data.flow_step_queue.step) {
          status = case_status[data.flow_step_queue.step.note];
        }
        if (!status) {
          status = case_status[data.status];
        }
        return <div><JobStatusComponent data={data} isManualStep={this.isManualStep(data)}/>  {status}</div>
      },
      sorter: (a, b) => a.status - b.status,
      sortOrder: sortedInfo.columnKey === 'status' && sortedInfo.order,
    }, {
      title: 'Updated',
      dataIndex: 'last_modified',
      render: (date) => moment(date).format('DD-MM-YYYY HH:mm:ss'),
      key: 'last_modified',
      sorter: (a, b) => Date.parse(a.last_modified) - Date.parse(b.last_modified),
      sortOrder: sortedInfo.columnKey === 'last_modified' && sortedInfo.order,
    }, {
      title: 'Created',
      dataIndex: 'created',
      render: (date) => moment(date).format('DD-MM-YYYY HH:mm:ss'),
      key: 'created',
      sorter: (a, b) => Date.parse(a.created) - Date.parse(b.created),
      sortOrder: sortedInfo.columnKey === 'created' && sortedInfo.order,
    }, {
      title: 'Flow',
      dataIndex: 'flow.type',
      render: (type) => tableTypes[type],
      key: 'flow',
    },
    {
      title: 'Plan type',
      dataIndex: 't_plan.plan_type.name',
      render: (plan_type) => plan_type,
      key: 'plan_type',
    },
    {
      title: 'Actions',
      render: (data) => {
        if (this.props.isSupervisor === true && this.shouldShowDeleteButton(data)) {
          const menuOverlay = <JobsMenu data={data} actions={actions} onJobDelete={this.props.deleteJob}/>
          return <ActionMenu overlay={menuOverlay} ignoreOnClick={true} iconType={"down"}/>;
        } else {
          return <DataFlowItem data={data} actions={actions} />;
        }
      },
      key: 'actions',
    },
  ];


    return (
      <div>
        <PanelBox title={"Case table"}>
          <Row style={{ marginBottom: 16 }}>
            <Col span={8} align="left">
              {this.shouldShowWaitingRadioButton() &&
                <Radio.Group defaultValue={JOB_STATUS_ALL} onChange={this.handleCaseTableRadioSwitch}>
                  <Radio.Button value={JOB_STATUS_ALL}>Active</Radio.Button>
                  <Radio.Button value={JOB_STATUS_WAITING}>Pending</Radio.Button>
                </Radio.Group>
              }
            </Col>
            <Col span={8} offset={8} align="right">
              <RangePicker
                placeholder={['Start date', 'End date']}
                style={{ width: 220, marginBottom: 10, textAlign: 'left' }}
                defaultValue={[moment().subtract(30, 'days'), moment()]}
                format={dateFormat}
                onChange={(evt) => {
                  let from = moment().subtract(30, 'days').format('YYYY-MM-DD');
                  let to = moment().format('YYYY-MM-DD');

                  if (evt[0] && evt[0]._d) {
                    from = moment(evt[0]._d).format('YYYY-MM-DD')
                  }

                  if (evt[1] && evt[1]._d) {
                    to = moment(evt[1]._d).format('YYYY-MM-DD')
                  }

                  this.requestJobs(from, to);
                }}
              />
              <br />
              <Input
                  prefix={<Icon type="search" />}
                  placeholder="Search"
                  style={{ width: 220 }}
                  onChange={(e) => this.onSearchHandler(e.target.value)}
              />
            </Col>
          </Row>
          <Table
            dataSource={source}
            id="case-table"
            columns={columns}
            rowKey="uuid"
            loading={this.state.tableLoading}
            onChange={this.handleChange}
            onRowClick={(item) => {
              const { note } = item.flow_step_queue.step;
              if (note === 'S_DATA_UPDATE') {
                window.location = `/case/plan-update-form/${item.uuid}`;
              } else if (
                note === 'S_QUALITY_CONTROL' ||
                note === 'S_CLINICIAN_REVIEW'
              ) {
                window.location = `/case/control/${item.flow.type.replace(/\_/g, '-')}/${item.uuid}`;
              } else if (note === 'S_PUBLISH' && app_type === 'standalone') {
                this.setState({
                  shareModal: true,
                  uuid: item.uuid,
                });
              } else if (
                note === 'S_OCCLUSAL_PLANE_SETUP' ||
                note === 'S_OCCLUSAL_PLANE' ||
                note === 'S_TRIM_BASE' ||
                note === 'S_GENERATE_BASE' ||
                note === 'S_TEETH_MARKUP' ||
                note === 'S_CROWN_SEGMENTATION' ||
                note === 'S_SEGMENTED_ASSET_CREATION' ||
                note === 'S_LOCAL_C_S' ||
                note === 'S_MODELLING'
              ) {
                window.open(`${ window.location.origin }/teeth-alignment-modelling/?uuid=${item.uuid}`, '_blank');
              } else {
                window.location = `/ctscan/?uuid=${item.uuid}&remote=${localStorage.getItem('API').replace('api/v1','')}`.replace(/\/$/g, '');
              }
            }}
          />
        </PanelBox>
        {
          (
            <Modal
              title="Share links"
              centered
              visible={this.state.shareModal}
              onOk={() => this.setState({ shareModal: false })}
              onCancel={() => this.setState({ shareModal: false })}
              cancelButtonProps={{
                style: {
                  display: 'none',
                }
              }}
            >
              <p style={{ margin: 0 }}>
                { 'Tech: ' }
                <a target='_blank' href={ `${ tech_api }/${ public_path }?uuid=${ this.state.uuid }` }>{ `${ tech_api }/${ public_path }?uuid=${ this.state.uuid }` }</a>
              </p>
              <p style={{ margin: '10px 0 0 0' }}>
                { 'Client: ' }
                <a target='_blank' href={ `${ client_api }/${ public_path }?uuid=${ this.state.uuid }` }>{ `${ client_api }/${ public_path }?uuid=${ this.state.uuid }` }</a>
              </p>
            </Modal>
          )
        }
      </div>
    );
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(CaseTableStaff)


// WEBPACK FOOTER //
// ./src/views/Cases/caseTableStaff.jsx